import script from "./MultiSelectPopulate.vue?vue&type=script&setup=true&lang=js"
export * from "./MultiSelectPopulate.vue?vue&type=script&setup=true&lang=js"

import "./MultiSelectPopulate.vue?vue&type=style&index=0&id=2ac39fb6&lang=css"

const __exports__ = script;

export default __exports__